import { ApiLanding } from '@/containers/api-landing';

export default function ApiLandingRoute() {
  return <ApiLanding />;
}
